<template>
  <!--  <div class="header" ref="innerElement" :class="isTop && device.type == DeviceType.PC ? 'bbg' : 'whitebg'">
  -->

  <!--   <donate v-if="showDonate" @closeWin="this.showDonate=false" /> -->
  <Teleport to="body">
    <div :class="['fixedRightbox', voyadaEnabled && 'fixedRightbox--voyada']">
      <div class="donate" v-gtag:click="'donate'" v-if="showDonateImg">
        <img src="/images/index/donate.svg" alt="" style="" @click="clickShowDonate()" />
      </div>

      <div class="local_icon" v-if="isLogin" @click="showNotice()">
        <img src="/images/icon_fixed1.png" class="bg" alt="" />
        <i class="badge" v-if="noticeNum > 0">{{ noticeNum }}</i>
      </div>
      <div class="local_icon" v-authenticated v-else>
        <img src="/images/icon_fixed1.png" class="bg" alt="" />
      </div>
      <!--    <pre>{{ JSON.stringify(favProducts, null, 2) }}</pre>  -->
      <div class="local_icon" v-authenticated @click="toFav()">
        <img v-if="fav.count > 0" src="/images/icon_fixed2_2.png" class="bg" alt="" />
        <img v-else src="/images/icon_fixed2.png" class="bg" alt="" />
      </div>
      <div class="local_icon" v-authenticated @click="clickShowCart()">
        <img src="/images/icon_fixed3.png" class="bg" alt="" />
        <i class="badge" v-if="cart && cart.count > 0">{{ cart.count }}</i>
      </div>
      <div class="local_icon" @click="totop()">
        <img src="/images/icon_fixed4.png" class="bg" alt="" />
      </div>
    </div>
    <template v-if="cart.showCartPanel">
      <CartEmpty v-if="!cart.count || cart.count <= 0" @closeCart="cart.closeCart()" />
      <Cart v-else @closeCart="cart.closeCart()" />
    </template>
    <template v-if="showNoticeBox">
      <NoticeBox :notice_lit="NoticeList" @closeNotice="closeNotice()" />
    </template>
  </Teleport>

  <HeaderVoyada
    v-if="voyadaEnabled"
    :isTop="isTop"
    :transparent="transparent"
    :isshownav="isshownav"
    :showUserNav="showUserNav"
    :showMobileLeftMenu="showMobileLeftMenu"
    :isLogin="isLogin"
    :avatarUrl="avatarUrl"
    :avatar="avater"
    :firstName="firstName ?? ''"
    :lastName="lastName ?? ''"
    :customerGroupId="user.customerGroupId != null ? String(user.customerGroupId) : ''"
    :accountId="user.accountId != null ? String(user.accountId) : ''"
    @showUmenu="showUmenu()"
    @showMUmenu="showMUmenu()"
    @update:showUserNav="showUserNav = $event"
    @changePage="changePage"
    @setLogout="setLogout"
    @showNotice="showNotice()"
    @switchLeftMenu="switchLeftMenu()"
    @closeMobileMenu="showMobileLeftMenu = false"
  />
  <template v-else>
    <!-- TODO: MobileNav is not rendered in classic (non-voyada) mode. It ships at the same time as the
         voyada flag so this is intentional for now. Add MobileNav here (via Teleport) when classic mode
         needs to support mobile nav independently. -->
    <div data-app-header class="header" ref="innerElement" :class="isTop || transparent == '1' ? 'bbg' : 'whitebg'">
      <div class="right">
        <a href="/" class="logo pc">
          <img src="/images/logo.png" class="bg" alt="logo" />
          <img src="/images/logo_g.png" class="bg" alt="logo" />
        </a>
        <a href="/" class="logo flex_mobile">
          <img src="/images/logo_g.png" class="bg" alt="logo" />
          <img src="/images/logo.png" class="bg" alt="logo" />
        </a>
      </div>
      <div class="flex_mobile" style="justify-content: flex-start; position: relative">
        <div @click="switchLeftMenu()" class="icon wap icon_nav"></div>
        <div @click="navClick()" class="icon wap icon_user"></div>
        <div
          v-if="showUserNav"
          @mouseleave="showUserNav = false"
          class="block usermenu"
          style="position: absolute; top: 100%; right: 0; width: 170px; z-index: 100"
        >
          <div style="height: 25px"></div>
          <div class="usernav_m" v-if="isLogin" style="height: auto; width: 165px; padding-left: 3px">
            <UserMenu :logoutUrl="logoutUrl" @setLogout="setLogout" />
          </div>
          <div class="usernav_m" style="height: 120px; width: 130px; padding-left: 3px" v-else>
            <div class="r" @click="changePage('login')">
              <img src="/images/icon_user_b.png" style="padding: 0px; height: 19px; width: 19px" />
              {{ t('common.login') }}
            </div>
            <div class="userline"></div>
            <div class="r" @click="changePage('register')">
              <img src="/images/pen.png" style="height: 19px; width: 19px; padding: 0px" />{{ t('common.signup') }}
            </div>
          </div>
        </div>
      </div>
      <div
        class="wapnav pc"
        :style="
          device.type == DeviceType.PC
            ? {
                'padding-right': '6rem'
              }
            : {}
        "
      >
        <div class="header-phone-menu">
          <div class="header-phone-trigger" tabindex="0">
            <img src="/images/home/phone-icon.svg" class="header-phone-icon" alt="" />
            <span>{{ currentContact.region }}:</span>
            <span>{{ currentContact.number }}</span>
          </div>
        </div>

        <MegaMenu />
        <div class="wapnav pc" :class="isshownav ? 'open' : ''">
          <CurrencySelector />
          <div class="flex" style="position: relative">
            <div
              @mouseenter="showUmenu()"
              @mouseleave="showUserNav = false"
              class="borderbox profilebox"
              v-if="!isLogin"
            >
              <i class="icon_user"></i>
              <span>{{ t('common.login') }}</span>
              <div class="block usermenu" style="height: 120px" v-if="showUserNav">
                <div style="height: 65px"></div>
                <div class="usernav">
                  <div class="r nonemember" @click="changePage('login')">
                    <img
                      src="/images/icon_user_b.png"
                      style="padding: 0px; height: 19px; width: 19px; margin-right: 3px"
                    />
                    {{ t('common.login') }}
                  </div>
                  <div class="userline"></div>
                  <div class="r nonemember" @click="changePage('register')">
                    <img
                      src="/images/pen.png"
                      style="width: 19px; height: 19px; padding: 0px; margin-right: 3px"
                    />
                    {{ t('common.signup') }}
                  </div>
                </div>
              </div>
            </div>
            <div
              @mouseenter="showMUmenu()"
              @mouseleave="showUserNav = false"
              class="borderbox profilebox"
              style="width: auto"
              v-else
            >
              <div>
                <img
                  v-if="avatarUrl && avatarUrl != ''"
                  style="width: 2.3rem; height: 2.3rem; border-radius: 50%"
                  :src="avatarUrl"
                  alt=""
                />
                <img
                  v-else-if="avater != ''"
                  style="width: 2.3rem; height: 2.3rem; border-radius: 50%"
                  :src="avater"
                  alt=""
                />
                <span style="font-size: 1.1917rem">{{ lastName }}/{{ firstName }}</span>
                <span
                  style="font-size: 1.1917rem; padding-left: 0.2rem; font-weight: normal"
                  v-if="user.customerGroupId == '3'"
                >
                  | {{ t('common.agentid') }}: {{ user.accountId }}
                </span>
              </div>
              <div class="block usermenu" v-if="showUserNav">
                <div style="height: 25px"></div>
                <div class="usernav">
                  <UserMenu @setLogout="setLogout" />
                </div>
              </div>
            </div>
            <div class="borderbox profilebox wap">
              <i class="icon_user"></i>
              <span> {{ t('common.signup') }}</span>
            </div>
          </div>
        </div>

        <div class="flex_mobile">
          <div
            @mouseleave="showUserNav = false"
            @click="showUserNav = !showUserNav"
            class="block usermenu"
            style="width: 170px; border: 0px solid red"
            v-if="showUserNav"
          >
            <div style="height: 25px"></div>
            <div
              class="usernav_m"
              v-if="isLogin"
              style="height: auto; width: 165px; padding-left: 3px"
            >
              <UserMenu :logoutUrl="logoutUrl" @setLogout="setLogout" />
            </div>
            <div class="usernav_m" style="height: 120px; width: 130px; padding-left: 3px" v-else>
              <div class="r" @click="changePage('login')">
                <img
                  src="/images/icon_user_b.png"
                  style="padding: 0px; height: 19px; width: 19px"
                />
                {{ t('common.login') }}
              </div>
              <div class="userline"></div>
              <div class="r" @click="changePage('register')">
                <img src="/images/pen.png" style="height: 19px; width: 19px; padding: 0px" />{{
                  t('common.signup')
                }}
              </div>
            </div>
          </div>
          <div class="borderbox profilebox wap">
            <i class="icon_user"></i>
            <span> {{ t('common.signup') }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 手机版左侧点击菜单 -->
    <div class="darkbg" v-if="showMobileLeftMenu"></div>
    <div v-if="showMobileLeftMenu" class="mobileleftmenu flex_mobile">
      <div class="block" style="width: 100%; display: flex; padding: 0px; margin: 0px">
        <div
          class="r"
          style="
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            padding: 15px 0px;
          "
        >
          <!-- <div @click="showMobileLeftMenu = false" style="font-size:2.0583rem; padding-left: 0px">X</div> -->
          <img
            src="/images/icon_close.png"
            @click="showMobileLeftMenu = false"
            class="close"
            style="width: 25px; height: 25px; display: block"
            alt=""
          />
          <div style="display: flex; justify-content: center; align-items: center">
            <img src="/images/logo_b.png" style="height: 25px; width: 100px" alt="" />
          </div>
          <img src="/images/icon_user_b.png" style="height: 25px; width: 25px" alt="" />
        </div>
      </div>
      <MegaMenu />
      <div class="mobile-phone-panel">
        <div class="mobile-phone-divider"></div>
        <div class="mobile-phone-title">
          <img src="/images/home/phone-icon.svg" class="mobile-phone-icon" alt="" />
          <span>{{ t('home.bookNow') }}</span>
        </div>
        <div class="mobile-phone-list">
          <span class="mobile-phone-item">
            <span>{{ currentContact.region }}:</span>
            <span>{{ currentContact.number }}</span>
          </span>
        </div>
      </div>
      <!-- <div class="list" style="position: relative; margin-top: 0px; padding-top: 0px; width: 100%"
      v-if="showMobileLeftMenu && headlist && headlist[1]" v-for="(item, index) in headlist[1]" :key="index">
      <div style="font-size:1.6rem;line-height:2.4rem" @click="showChild(item)" class="tit" :data-id="item.megamenu_id">
        {{ getItemTitle(item) }} <i class="icon"> </i>
      </div>
      <div class="childbox" v-if="item.showchild && headlist[item.megamenu_id]">
        <div v-for="(item1, index1) in headlist[item.megamenu_id]" :key="index1">
          <div style="width: 100%; padding-left: 8px;font-size:1.4rem;line-height:2.1rem">
            <span @click="toUrl(item1)">{{ getItemTitle(item1) }}</span>
            <div>
              <div @click="toUrl(item2)" class="subtitle"
                style="font-size:1.2rem;line-height:1.8rem;font-weight: normal; padding-left: 16px"
                v-for="(item2, index2) in headlist[item1.megamenu_id]" :key="index2">
                {{ getItemTitle(item2) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    </div>
  </template>

  <Donate v-if="showDonate" @closeWin="closeDonate" />
  <template v-if="showDialog === 'login'">
    <Login @setLogin="setLogin" @close="closeDialog()" @changePage="changePage" />
  </template>
  <Register
    @gotoNext="setLogin"
    v-if="showDialog === 'register'"
    @close="closeDialog()"
    @changePage="changePage"
  />
  <RecoverPass v-if="showDialog == 'recoverpass'" @close="closeDialog()" @changePage="changePage" />
  <Contact v-if="showDialog == 'contact'" @close="closeDialog()" @changePage="changePage" />
  <!--
      <div class="wap head" v-if="showMobileLeftMenu" style="position:fixed;left:0px;right:0px;z-index:9;height:100%;background:#fff">
            <a href="/#/" class="logo">
              <img src="/images/logo.png" class="bg" alt="logo" />
              <img src="/images/logo_b.png" class="bg" alt="logo" />
            </a>
            <img src="/images/icon_close.png" @click="showMobileLeftMenu = false" class="close" alt="" />
          </div> -->

  <div v-if="showAdTxt" style="" class="blackfriday_top">
    <div class="pc">
      {{ AdTitle }}
      {{ AdTxt }}
    </div>
    <div class="flex_mobile">
      <div style="width: 100%">
        {{ AdTitle }}
      </div>
      <div style="font-weight: normal; width: 100%">
        {{ AdTxt }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, toRefs, watch } from 'vue'
import Request from '@/services/Request'
import Login from '@/components/login.vue'
import Register from '@/components/register.vue'
import UserMenu from '@/components/usermenu.vue'
import RecoverPass from '@/components/recoverpass.vue'
import Contact from '@/components/contact.vue'
import { dataUrl } from '@/utils/AssetUtils.ts'
import { useUserStore } from '@/stores/UserStore'
import { DeviceType, useNavDevice } from '@/utils/DeviceUtils'
import { useCartStore } from '@/stores/CartStore'
import MegaMenu from './MegaMenu.vue'
import HeaderVoyada from './HeaderVoyada.vue'
import CurrencySelector from './CurrencySelector.vue'
import { useVoyadaFlag, voyadaHeroMode } from '@/composables/useVoyadaFlag'
import { showMobileLeftMenu, showMobileAccountSheet } from '@/composables/useMobileMenu'
import { useFavStore } from '@/stores/FavStore'
import Cart from './cart.vue'
import CartEmpty from './CartEmpty.vue'
import NoticeBox from './NoticeBox.vue'
import vAuthenticated from '@/directives/AuthenticatedDirective'
import Donate from '@/components/donate.vue'
import vGtag from '@/directives/GtagDirective'
import { useOrderStore } from '@/stores/OrderStore'
import { useI18n } from 'vue-i18n'
import { setLocale } from '@/utils/lang'
import { localDriver } from '@/utils/localDriver'
import { useHomepagePhoneContacts } from '@/composables/homepage'

const { t } = useI18n()
const { currentContact } = useHomepagePhoneContacts()
const { enabled: voyadaEnabled } = useVoyadaFlag()

let url = new URL(window.location.href)
let lan = url.searchParams.get('lan')
if (lan) {
  url.searchParams.delete('lan')
  setLocale(lan)
  document.location = url
}

const orderStore = useOrderStore()
const cart = useCartStore()
const userStore = useUserStore()
const user = userStore.user
userStore.waitInit().then(() => {
  if ('4' == user.customerGroupId && '/agentlogin/' != window.location.pathname) {
    window.location.href = '/agentlogin/#agencyRegister'
  }
})

const fav = useFavStore()
const { isLogin, avatar: avater, firstName, lastName } = toRefs(user)

const props = defineProps({
  avatarUrl: String,
  transparent: {
    type: String,
    default: ''
  }
})

let headerwp = ref(true)
let headerbbg = ref(true)
let logoutUrl = ref('/')
let NoticeList = ref(null)
let showNoticeBox = ref(false)

const innerElement = ref(null)
let showAdTxt = ref(false)
let AdTitle = ref('Cyber Week Deals! ')
let AdTxt = ref(
  ' Our team has sourced the finest selections from our global partners to craft the ultimate Cyber Week deals collection, just for our members.'
)
watch(
  () => userStore.user.customerId,
  (newValue, oldValue) => {
    if (pathname == '/' || pathname == '/game/landmark/') {
      avater.value = ref('/images/icon_user.png')
    }
  }
)

function loadNotice() {
  new Request().webPost(
    {},
    (res) => {
      if (res.success) {
        NoticeList.value = res.data.list
        noticeNum.value = res.data.num + res.data.list['product_inquire'].length
      }
    },
    'common/helpdesk/getLateNotice',
    (err) => {},
    3000,
    2
  )
}

function showNotice() {
  if (userStore.user.customerId) {
    if (noticeNum.value >= 0) {
      showNoticeBox.value = true
    }
  }
}

function getItemTitle(item) {
  let title = item.title
  if (item.type === 'category') {
    title += `(${item.product_count})`
  }
  return title
}

const emit = defineEmits(['loadUserInfo'])

let isshownav = ref(false)
let headlist = ref({})
let headitemlist = ref({})
let itemidx = ref([])
let hoverIdx = ref(0)
let componentKey = ref(0)
let translist = ref({})
let tripImage = ref('')
const { showLoginDlg: showDialog } = toRefs(userStore)
let customer_id = ref('')
let showUserNav = ref(false)
let noticeNum = ref(0)
let curIndex = ref(0)
let curIndex1 = ref(0)
let isTop = ref(true)
let userAvater = ref('')
let showDonate = ref(false)
let showDonateImg = ref(true)

const hash = window.location.hash
if (hash && hash == '#login') {
  changePage('login')
}

let pathname = window.location.pathname

function toFav() {
  if (isLogin.value) document.location = '/user/?active=1'
}

avater.value = ref('/images/icon_user.png')

const closeDialog = () => {
  userStore.closeLoginRequest()
}

function clickShowCart() {
  cart.openCart()
}

function clickShowDonate() {
  showDonate.value = true
}

const showUmenu = () => {
  if (showDialog.value != 'contact') {
    showMobileAccountSheet.value = false
    showUserNav.value = !showUserNav.value
  }
}

const showMUmenu = () => {
  if (showDialog.value != 'contact') {
    showMobileAccountSheet.value = false
    showUserNav.value = !showUserNav.value
  }
}
const toggleLogin = () => {
  showDialog.value = 'login'
}
const navClick = () => {
  if (!showUserNav.value) showUserNav.value = true
  else showUserNav.value = false
}

const openpage = () => {
  isshownav.value = false
  window.location.href = '#/triplist'
}

const treeMenu = ref(null)
function closeNotice() {
  showNoticeBox.value = false
}

function buildTreeMenu(root, childMenuId, items) {
  const childList = items[childMenuId]
  if (null == childList) {
    return
  }
  const children = []
  for (const childItem of childList) {
    const child = {
      text: getItemTitle(childItem),
      link: getUrl(childItem)
    }
    buildTreeMenu(child, childItem.megamenu_id, items)
    children.push(child)
  }
  root.children = children
}

const getmenu = () => {}

function totop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
}

const setLogout = async () => {
  document.location = '/'
}
const gotoNext = () => {
  isLogin.value = true
  getHeader()
}
const closeDonate = () => {
  showDonate.value = false
}

const setLogin = () => {
  setTimeout(() => {
    showDialog.value = ''
    // window.location.reload()
    closeDialog()
  }, 2000)
  getHeader()
}

const getMainTain = () => {
  new Request().webGet(
    {},
    (res) => {
      if (res.hasOwnProperty('heading_title') && res.heading_title == 'Maintenance') {
        document.location = '/maintenance/'
      }
    },
    'common/common/getSettingByCode&code=config_maintenance',
    (err) => {
      console.log(err)
    },
    3000,
    3
  )
}

const getHeader = async () => {
  let needLogin = false
  const href = window.location.href
  if (href.indexOf('/user/') > 0) {
    needLogin = true
  }

  const customer_id = await localDriver.getItem('customer_id')
  if (customer_id) {
    const queryParams = new URLSearchParams(window.location.search)
    const token = queryParams.get('token')
    new Request().webGet(
      {},
      (res) => {
        isLogin.value = res && res.logged > 0 ? true : false
        let base = res.base
        let _avater = ''

        if (res.hasOwnProperty('avater') && res.avater && res.avater != '') {
          _avater = base + res.avater
          if (_avater.indexOf('../') >= 0) _avater = _avater.replace('../', '') /* */
          avater.value = _avater
          userAvater.value = _avater
        }

        let _firstName = ''
        let _lastName = ''
        if (res.hasOwnProperty('customer_name') && res.customer_name) {
          let arr = res.customer_name.split('/')
          if (arr.length == 2) {
            _firstName = arr[1]
            _lastName = arr[0]
          } else _firstName = res.customer_name
        }

        firstName.value = _firstName
        lastName.value = _lastName
        let userInfo = {
          base: base,
          customer_id: res.logged,
          firstName: _firstName,
          lastName: _lastName,
          email: res.email,
          phone: res.phone,
          avater: _avater,
          accountId: res.accountId,
          membership: res.membership
        }
        if (!isLogin.value && needLogin) {
          changePage('login')
        }
        if (isLogin.value) {
          cart.setCount(res.cart && res.cart.count ? parseInt(res.cart.count) : 0)
        }
      },
      'common/header/getHeaderData' + (token ? '&token=' + token : ''),
      (err) => {},
      5000,
      3
    )
  } else {
    //console.log('no login')
    isLogin.value = false
  }
}
/*
  const tolist = (nav) => {
    if ($route.path == '/deslist') {
      $refs.child.changecontry(nav)
    } else {
      location.href = '#/deslist?contry=' + nav
    }
  }

  const addHoverClass = (item, idx) => {
    let curidx = itemidx.value[idx] ? itemidx.value[idx] : 0
    let curcid = 0
    headitemlist.value = {}
    if (
      headlist.value[item.megamenu_id] &&
      headlist.value[item.megamenu_id][curidx]?.megamenu_id &&
      headlist.value[headlist.value[item.megamenu_id][curidx].megamenu_id]
    ) {
      curcid = headlist.value[item.megamenu_id][curidx].item
      headitemlist.value = headlist.value[headlist.value[item.megamenu_id][curidx].megamenu_id]
    }
    hoverIdx.value = 0
    if (headitemlist.value[hoverIdx.value] && headitemlist.value[hoverIdx.value].image) {
      tripImage.value = `../../../../../image/${headitemlist.value[hoverIdx.value].image}`
    } else if (headlist.value[item.megamenu_id] && headlist.value[item.megamenu_id][curidx].image) {
      tripImage.value = `../../../../../image/${headlist.value[item.megamenu_id][curidx].image}`
    }
    translist.value = {
      curidx: 0,
      path: curcid,
      item: headitemlist.value
    }
    //console.log('headitemlist', headitemlist)
  }
   */
/* const removeHoverClass = (item) => {
    // if ($refs.downbox) {
    //   $refs.downbox.classList.add("headli1");
    // }
  }
  function getChildren(item, item1) {
    if (headlist.value[item1.megamenu_id]) {
      // curidx = item1.item;
      item1.children = headlist.value[item1.megamenu_id]
      //  headitemlist.value = headlist.value[item1.megamenu_id]
    }
  } */

const categoryHoverClass = (item1, idx, idx1) => {
  curIndex.value = idx
  curIndex1.value = idx1
  if (headlist.value[item1.megamenu_id]) {
    item1.children = headlist.value[item1.megamenu_id]
  } else {
    item1.children = false
  }
}

function showChild(item) {
  if (item.showchild) item.showchild = !item.showchild
  else item.showchild = true
}
// Touch screens never fire mouseleave, so an open user menu used to block the hamburger: close it instead.
function switchLeftMenu() {
  showUserNav.value = false
  showMobileLeftMenu.value = !showMobileLeftMenu.value
}

function getUrl(magaMenuItem) {
  const url = magaMenuItem
  if (url.type == 'category') {
    const baseUrl = import.meta.env.BASE_URL
    let to
    if (baseUrl.endsWith('/')) {
      to = baseUrl + 'search/?catId=' + url.item
    } else {
      to = baseUrl + '/search/?catId=' + url.item
    }
    return to
  }
}

function toUrl(url) {
  if (url.type == 'category') {
    const baseUrl = import.meta.env.BASE_URL
    let to
    if (baseUrl.endsWith('/')) {
      to = baseUrl + 'search/?catId=' + url.item
    } else {
      to = baseUrl + '/search/?catId=' + url.item
    }

    document.location.href = to
  }
}

function changePage(pageName) {
  showDialog.value = pageName
}
const checkLogin = () => {
  customer_id.value = sessionStorage.getItem('customer_id')
  if (!customer_id.value) {
    showDialog.value = 'login'
  } else {
    document.location = '/user/'
  }
}
function openContact() {
  if (showDialog.value == '') showDialog.value = 'contact'
  else showDialog.value = ''
}
const device = useNavDevice()

watch(
  () => device.type,
  (type) => {
    if (type === DeviceType.PC) showMobileLeftMenu.value = false
  }
)

// NOTE: intentionally NO <body> scroll-lock. Manipulating <body> overflow/position froze
// the mobile menu's own touch scrolling on iOS WebKit, so the lock was removed. The menu
// (src/components/MobileMenu.vue — .mm-menu) is a full-viewport opaque overlay that hides
// the background; see that file for the z-index requirement vs the Voyada SDK drawer.

function handleScroll() {
  const _top = window.scrollY === 0
  isTop.value = _top
  let pathname = window.location.pathname
  if (pathname == '/' && userAvater.value == '' && voyadaHeroMode.value !== 'voyada') {
    if (!_top) avater.value = '/images/icon_user_b.png'
    else avater.value = '/images/icon_user.png'
  }
}

onMounted(async () => {
  if (typeof window.Notification === 'undefined') {
    window.Notification = undefined
  }
  getMainTain()
  loadNotice()
  let clicked_donate = await localDriver.getItem('clicked_donate')
  const href = window.location.href
  try {
    if (href.indexOf('referral') > 0) {
      const arr = href.split('?')
      if (arr.length == 2) {
        const accountid = arr[1]
        if (accountid) {
          await localDriver.setItem('ref_accountid', accountid)
        }
      }
    }
    getHeader()
    let pathname = window.location.pathname
    if (pathname == '/') {
      window.addEventListener('scroll', handleScroll)
    } else isTop.value = false
  } catch (error) {}
})
onUnmounted(() => {
  let pathname = window.location.pathname
  if (pathname == '/') window.removeEventListener('scroll', handleScroll)
})
defineExpose({ innerElement, setLogin })
</script>
<style>
.donate {
  position: absolute;
  top: -7rem;
  display: flex;

  width: 5rem;
  cursor: pointer;
  justify-content: center;
}

.donate img {
  width: 4.3rem;
  height: 4.3rem;
}

.fixedRightbox {
  background: #ffffff;
  border: 1px solid #eaeaea;
  border-radius: 3rem;
  box-sizing: border-box;
  position: fixed;
  right: 3rem;
  top: 55%;
  z-index: 8;
}

.fixedRightbox .local_icon {
  padding: 0.4rem;
  width: 5rem;
  height: 5rem;
  border-radius: 50%;
  position: relative;
  cursor: pointer;
}

.fixedRightbox .local_icon + .local_icon::after {
  content: '';
  border-top: 1px solid #eaeaea;
  width: 2.2rem;
  height: 0;
  position: absolute;
  top: 0;
  left: calc(50% - 1.1rem);
}

.fixedRightbox .local_icon .badge {
  font-size: 1.4rem;
  font-weight: 500;
  line-height: 2rem;
  text-align: center;
  color: #fff;
  padding: 0 0.4rem;
  min-width: 2rem;
  box-sizing: border-box;
  background: #ff5722;
  border-radius: 50%;
  display: block;
  position: absolute;
  top: 0;
  right: 0;
}

.header.bbg .profilebox { border: 1px solid rgba(255, 255, 255, 0.6) !important; }
.header.whitebg .profilebox { border: 1px solid #4f6f52 !important; }

.nonemember {
  width: 60%;
  margin: auto;
}

.usermenu {
  position: absolute;
  top: 15px;
  right: 0px;
  z-index: 99999;
  justify-content: flex-start;
  align-items: flex-start;
}

.navright {
  justify-content: flex-end !important;
  /* padding-right: 50px !important; */
}

.flex_mobile {
  display: none;
}

/* .blackfriday_top .flex_mobile {
  display: none !important;
}
 */
.pc {
  display: block;
}

.usernav {
  padding: 5px 5px;
  height: auto;
  width: 190px;
  background: #fff;
  border-radius: 10px;
  color: #333;
  z-index: 9999 !important;
}

.usernav .r {
  align-items: center;
  display: flex;
  flex-direction: row;
}

.usernav .r:hover {
  background: #e5e5e5;
  border-radius: 15px;
}

.usernav img {
  height: 25px;
  width: 25px;
  margin-right: 5px;
}

.usernav_m {
  padding: 5px 5px;
  height: auto;
  width: 190px;
  background: #fff;
  border-radius: 10px;
  color: #333;
  z-index: 9999 !important;
  font-size: 1.2rem;
}

.usernav_m .r {
  align-items: center;

  display: flex;
  flex-direction: row;
}

.usernav_m .r:hover {
  background: #e5e5e5;
  border-radius: 15px;
}

.usernav_m img {
  height: 25px;
  width: 25px;
  margin-right: 5px;
}

.userline {
  border-top: 1px solid #ddd !important;
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}

.childcate {
  position: absolute;
  border-radius: 10px;
  border-top-left-radius: 0px;
  /* width: 150px; */
  /* right: 0px; */
  left: 50%;
  top: 0px;
  z-index: 999;
  background: #fff;
}

.subtitle {
  text-align: left;
  padding: 2px 10px;
  min-width: 80%;
  font-weight: bold;
  padding-left: 1rem;
  padding-right: 1rem;
  margin-left: 1rem;
  margin-right: 1rem;
}

a {
  text-underline-offset: initial;
}
</style>
<style scoped>
.libox {
  background: #fff;
  position: absolute;
}

.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 99;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  color: #fff;
  height: 7rem;
  padding: 0 26rem;
}

.header.bbg {
  transition: all 0.3s ease 0s;
  color: #fff;
  background: linear-gradient(to bottom, rgba(50, 49, 49, 0.5), rgba(41, 40, 40, 0));
}

.header.whitebg {
  background: #fff;
  color: #333;
  transition: all 0.3s ease 0s;
}

.header .logo {
  width: 15rem;
}

.header-phone-menu {
  position: relative;
  display: flex;
  align-items: center;
  height: 7rem;
  margin-right: 2.4rem;
  color: inherit;
  font-family: Poppins;
  white-space: nowrap;
}

.header-phone-trigger {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  font-size: 1.4rem;
  font-weight: 600;
  line-height: 2.2rem;
  outline: none;
}

.header-phone-icon {
  width: 1.7rem;
  height: 1.8rem;
  object-fit: contain;
}

.header.bbg .header-phone-icon {
  filter: brightness(0) invert(1);
}

.header.whitebg .header-phone-icon {
  filter: none;
}

.header-phone-label {
  margin-right: 0.2rem;
}

.header .logo img:first-child {
  display: none;
}

.header.bbg .logo img:first-child {
  display: block;
}

.header.bbg .logo img:last-child {
  display: none;
}

/* .transparent_header .logo img:first-child {
  display: block;

}

.transparent_header .logo img:last-child {

  display: none;
} */

.header .right,
.header .wapnav,
.header .listbox {
  display: flex;
  justify-content: center;
  align-items: center;
}

.header .listbox .list {
  position: relative;
  margin-right: 4rem;
}

.header .listbox .list .tit {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.4rem;
  font-weight: 600;
  line-height: 7rem;
  cursor: pointer;
  white-space: nowrap;
}

.header .listbox .list .tit i {
  width: 2rem;
  height: 2rem;
  display: block;
  margin-left: 0.6rem;
  background: url(/images/icon_down_w.png) center no-repeat;
  background-size: 100% 100%;
  transition: all 0.3s ease 0s;
}

.header.bbg .listbox .list .tit i {
  background: url(/images/icon_down_w.png) center no-repeat;
  background-size: 100% 100%;
}

.header.whitebg .listbox .list .tit i {
  background: url(/images/icon_down_b.png) center no-repeat;
  background-size: 100% 100%;
  align-self: center !important;
  margin-top: 0px;
}

.header .listbox .list:hover .tit i {
  transform: rotate(-180deg);
}

.header .listbox .list:hover .childbox {
  display: block;
  margin-bottom: 5rem;
  padding-bottom: 5rem;
  max-height: 80vh;
}

.header .listbox .list .childbox {
  position: absolute;
  top: 99%;
  left: -2.4rem;
  background: #ffffff;
  box-shadow: 0px 1rem 6rem -1rem rgba(0, 0, 0, 0.078);
  border-radius: 1.2rem;
  color: #333;
  padding: 10px 0px;
  line-height: 3.6rem;
  font-size: 1.4rem;
  min-width: 30rem;
  display: none;
}

.tourtitle {
  padding: 0px 10px;
}

.currentCate1 {
  padding: 0px 10px;
  background: rgba(76, 167, 113, 0.2);
  border-radius: 10px;
  padding-left: 1rem;
  padding-right: 1rem;
  overflow: hidden;
}

.subtitle:hover {
  background: rgba(76, 167, 113, 0.2);
  border-radius: 10px;
}

.wider {
  width: 34rem;
}

.header .listbox .list .childbox .link {
  padding: 0 0 10px 10px;
  display: block;
  white-space: nowrap;
  border-radius: 10px;
  cursor: pointer;
  margin: 0px;
}

.header .borderbox {
  margin-left: 1.2rem;
  border: 1px solid #eaeaea;
  padding: 0 1.2rem;
  height: 3.6rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 1.8rem;
  cursor: pointer;
}

.header .borderbox span {
  margin-left: 0.6rem;
  font-size: 1.4rem;
  font-weight: 700;
  line-height: 2rem;
}

.header .borderbox .icon_down {
  margin-left: 0.6rem;
}

.header .borderbox > div {
  display: flex;
  justify-content: center;
  align-items: center;
}

.header .borderbox i {
  display: block;
  width: 2rem;
  height: 2rem;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}

.header .borderbox i.icon {
  background-image: url(/images/icon_down_w.png);
}

.header.whitebg .borderbox i.icon {
  background-image: url(/images/icon_down_b.png);
}

.header .borderbox i.icon_msg {
  background-image: url(/images/icon_msg.png);
}

.header.whitebg .borderbox i.icon_msg {
  background-image: url(/images/icon_msg_b.png);
}

.header .borderbox i.icon_user {
  background-image: url(/images/icon_user.png);
}

.header.whitebg .borderbox i.icon_user {
  background-image: url(/images/icon_user_b.png);
}

@media screen and (max-width: 750px) {
  .donate {
    position: absolute;
    top: -5rem;
    display: flex;
    width: 3.6rem;
    cursor: pointer;
    justify-content: center;
  }

  .donate img {
    width: 2.8rem;
    height: 2.8rem;
  }

  .fixedRightbox .local_icon .badge {
    font-size: 0.8rem;
    font-weight: 500;
    line-height: 1.2rem;
    text-align: center;
    color: #fff;
    padding: 0 0rem;
    min-width: 1.2rem;
    box-sizing: border-box;
    background: #ff5722;
    border-radius: 50%;
    display: block;
    position: absolute;
    top: 0.5rem;
    right: 0;
  }

  .fixedRightbox {
    right: 1.6rem;
    top: 60%;
  }

  .fixedRightbox .local_icon {
    width: 3.5rem;
    height: 3.5rem;
  }

  .fixedRightbox--voyada {
    display: none;
  }
}
</style>

<style scoped>
@media screen and (max-width: 750px) {
  .flex_mobile {
    display: flex !important;
  }

  .header {
    z-index: 1000;
  }

  .usermenu {
    border: 1px solid #ddd !important;
    top: 4rem;
    background: #fff;
    height: auto;
    width: 16rem;
    right: 1.5rem;
    z-index: 99999 !important;
  }

  .mobileleftmenu {
    min-height: 15rem;
    padding: 8px 15px;
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    z-index: 9999;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    max-height: 90vh;
    overflow-y: auto;

    .r div {
      width: 33%;
    }
  }

  .mobile-phone-panel {
    width: 100%;
    padding: 0.8rem 0.9rem 1.2rem;
    box-sizing: border-box;
    color: #333;
    font-family: Poppins;
  }

  .mobile-phone-divider {
    width: 100%;
    height: 1px;
    margin-bottom: 0.8rem;
    background: #cccccc;
  }

  .mobile-phone-title {
    display: flex;
    gap: 0.6rem;
    align-items: center;
    margin-bottom: 0.8rem;
    font-size: 1.2rem;
    font-weight: 600;
    line-height: 1.8rem;
  }

  .mobile-phone-icon {
    width: 12px;
    height: 12px;
    object-fit: contain;
  }

  .mobile-phone-list {
    display: flex;
    flex-wrap: wrap;
    gap: 0.6rem;
    font-size: 1.2rem;
    font-weight: 600;
    line-height: 1.8rem;
  }

  .mobile-phone-item {
    display: flex;
    gap: 0.6rem;
    align-items: center;
    white-space: nowrap;
  }

  .mobile-phone-item:not(:last-child)::after {
    content: '|';
    margin-left: 0.6rem;
    color: #cccccc;
    font-weight: 500;
  }

  .flex_mobile {
    display: flex;
    justify-items: flex-start !important;
    align-items: flex-start !important;
    justify-content: flex-start !important;
  }

  .pc {
    display: none;
  }

  .navright {
    padding-right: 0px !important;
  }

  .header {
    background-color: rgba(246, 246, 246, 0.5);
    height: 5.6rem;
    padding: 0 2.4rem;
  }

  /*   .transparent_header {
    background-color: none!important;
} */
  .header.border {
    border-bottom: 1px solid #eaeaea;
  }

  .header.bbg,
  .header.whitebg {
    height: 5.5rem;
    padding: 0 2.4rem;
  }

  .header.bbg {
    color: #fff;
    background: linear-gradient(to bottom, rgba(50, 49, 49, 0.5), rgba(41, 40, 40, 0));
  }

  .header.whitebg {
    background: #fff;
    color: #333;
  }

  .header .logo {
    width: 13.5rem;
  }

  .header.bbg .logo img:first-child {
    display: none;
  }

  .header.bbg .logo img:last-child {
    display: block;
  }

  .header.whitebg .logo img:first-child {
    display: block;
  }

  .header.whitebg .logo img:last-child {
    display: none;
  }

  .header .wapnav {
    position: fixed;
    top: 0;
    left: 0px;
    width: 100%;
    height: 80%;
    padding: 0 0;
  }

  .wapnav.open {
    left: 0;
  }

  .wapnav .head {
    height: 5.6rem;
    display: flex !important;
    justify-content: space-between;
    align-items: center;
    padding: 0 2.4rem;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    box-sizing: border-box;
  }

  .wapnav .head .close {
    width: 3.4rem;
    height: 3.4rem;
    cursor: pointer;
    margin-left: 1.6rem;
  }

  .header.bbg .listbox .list .tit i {
    background: url(/images/icon_down_b.png) center no-repeat;
    background-size: 100% 100%;
  }

  .wapnav .listbox {
    display: block;
    padding: 1.6rem 0 2.4rem;
    box-sizing: border-box;
    margin: 5.6rem 0 0;
    border-bottom: 1px solid #eaeaea;
  }

  .header .listbox .list {
    margin: 0;
  }

  .header .listbox .list .tit {
    justify-content: space-between;
    font-size: 2rem;
    line-height: 5.6rem;
    cursor: pointer;
  }

  .header .listbox .list .childbox {
    position: relative;
    top: -1rem;
    left: 0;
    box-shadow: none;
    border-radius: 0;
    font-size: 1.6rem;
    padding: 0 1rem 1rem;
    min-width: none;
  }

  .header .flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .header .flex .borderbox {
    width: 45%;
    display: flex !important;
    margin-left: 0;
    box-sizing: border-box;
    height: 36px;
    border-radius: 18px;
  }

  .header .icon {
    width: 2rem;
    height: 2rem;
    margin-left: 2rem;
  }

  .header.bbg .borderbox i.icon {
    background-image: url(/images/icon_down_b.png);
  }

  .header.bbg .borderbox i.icon_msg {
    background-image: url(/images/icon_msg_b.png);
  }

  .header.bbg .borderbox i.icon_user {
    background-image: url(/images/icon_user_b.png);
  }

  .header .flex_mobile .icon_nav {
    background-image: url(/images/user/user_b.png);
    display: block;
    width: 2rem;
    height: 2rem;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    margin-left: 0;
  }

  .header.whitebg .flex_mobile .icon_nav {
    background-image: url(/images/icon_nav_wap.png);
  }

  .header .flex_mobile .icon_user {
    background-image: url(/images/icon_user.png);
    display: block;
    width: 2rem;
    height: 2rem;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
  }

  .header.whitebg .flex_mobile .icon_user {
    background-image: url(/images/icon_user_b.png);
  }

  /*
  .blackfriday_top {
    z-index: 999999;

    background: #00F1BD;
    margin-top: 5.8rem;
    height: auto;
    padding: 0.9rem 0;
  }

  .blackfriday_top .flex_mobile {
    display: flex;
    flex-direction: column !important;
    justify-items: center !important;

    align-items: center !important;
    justify-content: center !important;
  }

  .blackfriday_top .flex_mobile div {


    text-align: center;
    line-height: 1.5rem;
    height: auto;
    font-size: 0.95rem;
  } */
}
</style>
